module.exports = __webpack_public_path__ + "img/db.22fc1a53.jpg";